import React, { Component } from "react";

export default class BarclasiPasan extends Component {
	render() {
		let clase = "bar fill";

		return (
			<div className="barcontclasi">
				<div className="bar barkeyclasi">
					<span className="numero">{`${this.props.indice}.`}</span>
					{this.props.clave}
				</div>
				<div className="bar barfill">
					<div
						className={clase}
						style={{
							width: `${this.props.percent}%`,
							backgroundColor: this.props.pasa
								? this.props.mainColor
								: "#5F5F5F"
						}}
					>
						<span className="barper">{`${this.props.percent}%`}</span>
					</div>
				</div>
				<div className="bar bardata">
					<span className="strong" />
					{this.props.puntos}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BarclasiPasan.js